var _path, _tspan, _path2, _path3, _tspan2, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeakerCTube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 239,
    viewBox: "0 0 140 239",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5C0 2.23858 2.23858 0 5 0H135C137.761 0 140 2.23858 140 5V28H0V5Z",
    fill: "#3E6586"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Bio Sans",
    fontSize: 16,
    letterSpacing: "0em"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 37.5312,
    y: 19.6
  }, "Beaker C"))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 28.5H139.5V51C139.5 53.4853 137.485 55.5 135 55.5H5C2.51472 55.5 0.5 53.4853 0.5 51V28.5Z",
    fill: "#CCD8E1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 28.5H139.5V51C139.5 53.4853 137.485 55.5 135 55.5H5C2.51472 55.5 0.5 53.4853 0.5 51V28.5Z",
    stroke: "#3E6586"
  })), /*#__PURE__*/React.createElement("text", {
    fill: "#003E6B",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Bio Sans",
    fontSize: 16,
    letterSpacing: "0em"
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 4.46094,
    y: 47.6
  }, "1/1 Dialysis tubes"))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70 67.25L57 56L83 56L70 67.25Z",
    fill: "#3E6586"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M117.397 92.5829C116.747 93.916 115.212 94.6006 113.767 94.2043L111.853 93.6638C106.5 96 106 98 105.839 105V232.839C105.839 236.208 103.094 238.946 99.7163 238.946L30.4562 239C27.061 239 24 236.498 24 233.129V87C24 84.55 23.5934 82.3685 22.2209 80.3148C21.4985 78.7655 22.6363 77 24.352 77H95.689C103.401 77 110.769 80.1526 116.079 85.7012C118.011 87.4487 118.553 90.259 117.397 92.5829Z",
    fill: "#D9ECF6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8751 178L98.1422 177.949C101.373 177.949 104 175.341 104 172.133V110.5C76.1972 109.539 61.5 105.5 26 105.5V172.167C26 175.392 28.6265 178 31.8751 178Z",
    fill: "#33BEF2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1149 122.948H28.7767C28.1085 122.948 27.5667 123.488 27.5667 124.155C27.5667 124.821 28.1085 125.362 28.7767 125.362H54.1149C54.7831 125.362 55.3249 124.821 55.3249 124.155C55.3249 123.488 54.7831 122.948 54.1149 122.948Z",
    fill: "white",
    fillOpacity: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26 115V229.165C26 232.401 28.6242 235.017 31.8699 235L98.0783 234.948C101.307 234.948 104 232.219 104 229V107C104 106.415 103.965 105.585 104 105C76.757 105.258 64 115 26 115Z",
    fill: "#66CEF5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7024 113H38.2976C37.0274 113 36 114.149 36 115.569V231.638C36 233.496 37.345 235 39.0075 235H47.9925C49.655 235 51 233.496 51 231.638V115.569C51 114.149 49.9726 113 48.7024 113Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 228.051C30 228.578 30.4445 229 31 229C31.0743 229 31.1466 228.993 31.2161 228.978C31.2822 228.993 31.3508 229 31.4212 229H39.8191C40.3429 229 40.7763 228.556 40.7944 228C40.7944 227.445 40.3609 227 39.8191 227H32V213H39.8191C40.3429 213 40.7763 212.556 40.7944 212C40.7944 211.444 40.3609 211 39.8191 211H32V197H39.8191C40.3429 197 40.7763 196.556 40.7944 196C40.7944 195.445 40.3609 195 39.8191 195H32V181H39.8191C40.3429 181 40.7763 180.556 40.7944 180C40.7944 179.445 40.3609 179 39.8191 179H32V165H39.8191C40.3429 165 40.7763 164.556 40.7944 164C40.7944 163.445 40.3609 163 39.8191 163H32V149H39.8191C40.3429 149 40.7763 148.556 40.7944 148C40.7944 147.445 40.3609 147 39.8191 147H32V133H39.8191C40.3429 133 40.7763 132.556 40.7944 132C40.7944 131.445 40.3609 131 39.8191 131H32V117H39.8191C40.3429 117 40.7763 116.556 40.7944 116C40.7944 115.445 40.3609 115 39.8191 115H32V101H40.3731C40.8968 101 41.3303 100.556 41.3483 100C41.3483 99.4445 40.9149 99.0001 40.3731 99.0001H31.9752C31.8021 99.0001 31.64 99.0454 31.4996 99.1253C31.353 99.0455 31.1825 99.0001 31 99.0001C30.4445 99.0001 30 99.4218 30 99.949V228.051Z",
    fill: "#668BA6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3461 79H28.7872C28.1132 79 27.5667 79.4478 27.5667 80C27.5667 80.5523 28.1132 81 28.7872 81H54.3461C55.0201 81 55.5667 80.5523 55.5667 80C55.5667 79.4478 55.0201 79 54.3461 79Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeakerCTube);
export default __webpack_public_path__ + "static/media/Beaker_C_Tube.dc8ec58de618338319ffaea3ed745aa1.svg";
export { ForwardRef as ReactComponent };